"use strict";

exports.__esModule = true;
exports.default = void 0;
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var transitionName = 'uppy-transition-slideDownUp';
var duration = 250;

/**
 * Vertical slide transition.
 *
 * This can take a _single_ child component, which _must_ accept a `className` prop.
 *
 * Currently this is specific to the `uppy-transition-slideDownUp` transition,
 * but it should be simple to extend this for any type of single-element
 * transition by setting the CSS name and duration as props.
 */
function Slide(_ref) {
  var children = _ref.children;
  var _useState = (0, _hooks.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    cachedChildren = _useState2[0],
    setCachedChildren = _useState2[1];
  var _useState3 = (0, _hooks.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    className = _useState4[0],
    setClassName = _useState4[1];
  var enterTimeoutRef = (0, _hooks.useRef)();
  var leaveTimeoutRef = (0, _hooks.useRef)();
  var animationFrameRef = (0, _hooks.useRef)();
  var handleEnterTransition = function handleEnterTransition() {
    setClassName("".concat(transitionName, "-enter"));
    cancelAnimationFrame(animationFrameRef.current);
    clearTimeout(leaveTimeoutRef.current);
    leaveTimeoutRef.current = undefined;
    animationFrameRef.current = requestAnimationFrame(function () {
      setClassName("".concat(transitionName, "-enter ").concat(transitionName, "-enter-active"));
      enterTimeoutRef.current = setTimeout(function () {
        setClassName('');
      }, duration);
    });
  };
  var handleLeaveTransition = function handleLeaveTransition() {
    setClassName("".concat(transitionName, "-leave"));
    cancelAnimationFrame(animationFrameRef.current);
    clearTimeout(enterTimeoutRef.current);
    enterTimeoutRef.current = undefined;
    animationFrameRef.current = requestAnimationFrame(function () {
      setClassName("".concat(transitionName, "-leave ").concat(transitionName, "-leave-active"));
      leaveTimeoutRef.current = setTimeout(function () {
        setCachedChildren(null);
        setClassName('');
      }, duration);
    });
  };
  (0, _hooks.useEffect)(function () {
    var child = (0, _preact.toChildArray)(children)[0];
    if (cachedChildren === child) return;
    if (child && !cachedChildren) {
      handleEnterTransition();
    } else if (cachedChildren && !child && !leaveTimeoutRef.current) {
      handleLeaveTransition();
    }
    setCachedChildren(child);
  }, [children, cachedChildren]); // Dependency array to trigger effect on children change

  (0, _hooks.useEffect)(function () {
    return function () {
      clearTimeout(enterTimeoutRef.current);
      clearTimeout(leaveTimeoutRef.current);
      cancelAnimationFrame(animationFrameRef.current);
    };
  }, []); // Cleanup useEffect

  if (!cachedChildren) return null;
  return (0, _preact.cloneElement)(cachedChildren, {
    className: (0, _classnames.default)(className, cachedChildren.props.className)
  });
}
var _default = exports.default = Slide;